'use strict';

const { gsap } = require("gsap");
const { CustomEase } = require("gsap/CustomEase");
const { ScrollTrigger } = require("gsap/ScrollTrigger");
const { Draggable } = require("gsap/Draggable");
const BREAKPOINTS = require("../../../experience/breakpoints.json");
const labelHover = require("./steps/labelHover");
const {updateStepperHeight} = require("./stepper");
const answerWithImageBkgrd = require("./steps/answerWithImageBkgrd");
const stepper = require("./stepper");
const swiper = require("./swiper");
const slidingRadioButtons = require("./steps/slidingRadioButtons");

gsap.registerPlugin(ScrollTrigger, Draggable, CustomEase);

const animateLoader = ( hideScrollBar = false ) => {
    //region Animate loader bar
    const loaderTl = gsap.timeline({ defaults: { duration: 1 } });
    loaderTl
        .to('.loading_screen__bar', { duration: 2, right: '0%' }, '.5')
        .to('.loading_screen__bar', { left: '100%' }, '>')
        .addLabel('startExperienceEnter', '>')
        .to('.loading_screen', { opacity: 0 }, 'startExperienceEnter');

    /* Start the experience apparition */
    loaderTl.fromTo('.steps .step__start_experience', { autoAlpha: 0 }, { autoAlpha: 1 }, 'startExperienceEnter');

    if ( hideScrollBar ) {
        loaderTl.timeScale(10000);
    }

    // Focus on the first step title
    loaderTl.call(() => {
        const firstStepTitle = $('.step')[0];
        firstStepTitle.focus();
    }, null, '>');
    //endregion
};

const animateStepper = (answer, stepAnswers = null) => {
    let answerIndex = 0;

    if (answer !== 0) {
        stepAnswers = $(answer).closest('.step__answers');
        answerIndex = parseInt($(answer).data('answer-index'));
    }

    gsap.set(stepAnswers, {
        '--current-choice-index': answerIndex,
    });
};

const animateBeforeStep = async (form, duration) => {
    if ($('body').hasClass('mobile') && $(form).is('.step__type--labelHover, .step__type--answerWithImageBkgrd, .step__type--stars')) {
        $(form).find('.step__answers_wrapper').animate( { scrollTop: 0 }, duration );

        // Wait for the scroll animation to finish
        await new Promise(res => setTimeout(res, duration));
    }
};

const animateStep = ( step, timeline, oppositeDirection ) => {
    timeline.to( step, {
        position: 'absolute',
        yPercent: oppositeDirection ? 100 : -100,
    }, 0 );

    // Remove step
    if (oppositeDirection) {
        timeline.call( () => { $(step).remove(); }, null, '>' );
    }

    timeline.addLabel('end_of_previous_step', '>');

    timeline.set( step, {
        ariaHidden: 'true',
        display: 'none',
        duration: 0,
    }, 'end_of_previous_step' );
};

const animatePreviousStepBackground = (previousStep, timeline, position = 0) => {
    timeline.to( $(previousStep).find('.step__background'), {
        scale: 1.3,
        opacity: 0.2,
        clearProps: 'all',
    }, position );
};

const animateNextStepBackground = (nextStep, timeline, position = 0) => {
    timeline.fromTo(
        $(nextStep).find('.step__background'),
        { scale: 1.3, opacity: 0.2 },
        { scale: 1, opacity: 1, clearProps: 'all' },
        position
    );
};

const animateNextStep = (step, stepType, timeline, oppositeDirection) => {
    //region Update overflow
    if (stepType === 'recommendation') {
        timeline.set( '#maincontent, #product-finder-container',{
            overflow: 'initial'
        }, 'end_of_previous_step' );

        timeline.set( step, {
            zIndex: 0
        }, '>' );
    } else {
        const isDesktop = window.innerWidth > BREAKPOINTS.tablet;
        timeline.set('#maincontent, #product-finder-container', {
            overflow: isDesktop ? 'hidden' : 'auto'
        }, '<' );

        gsap.set(step, { zIndex: -1 });
    }
    //endregion

    if (oppositeDirection) {
        timeline.set( step, {
            ariaHidden: 'false',
            display: 'inherit',
            duration: 0,
        }, 0 );
    }

    animateNextStepBackground(step, timeline);
    switch (stepType) {
        case 'recommendation':
            timeline
                .fromTo( step,
                    { yPercent: oppositeDirection ? 0 : 100 },
                    { yPercent: oppositeDirection ? 100 : 0, clearProps: 'all' },
                    0
                )
                .addLabel('end_of_next_step', '>');

            // Add recommendation class to the footer
            timeline.call( () => {
                timeline.set('footer', {
                    clearProps: 'all',
                });

                $('body').addClass('step__type--recommendation');
                $('footer').addClass('footer--recommendation').attr('aria-hidden', 'false');
                updateStepperHeight();
            },
            undefined,
            'end_of_next_step'
            );

            break;
        case 'labelHover':
            labelHover.animate();
            defaultStepEnterAnimation(step, timeline, oppositeDirection);
            break;
        default:
            defaultStepEnterAnimation(step, timeline, oppositeDirection);
            break;
    }
};

const animatePreviousStep = (step, stepType, timeline, oppositeDirection) => {
    animatePreviousStepBackground(step, timeline);
    switch (stepType) {
        case 'recommendation':
            break;

        case 'answerWithImageBkgrd':
            answerWithImageBkgrd.animate(step, timeline, oppositeDirection);
            break;

        default:
            animateStep(step, timeline, oppositeDirection);
            break;
    }
};

const getStepType = (step) => {
    const stepTypeClass = Array.from(step.classList).find((className) => className.startsWith('step__type--'));
    return stepTypeClass ? stepTypeClass.split('step__type--')[1] : '';
};

const animateSteps = async (oppositeDirection = false, duration = window.STEP_ANIMAION_DURATION) => {
    // Get previous step and next step
    let previousStep = $('#product-finder-container .steps .step:nth-last-child(2)')[0];
    let nextStep = $('#product-finder-container .steps .step:last-child')[0];

    const stepNumber = oppositeDirection
        ? parseInt($(previousStep).attr('step-number')) - 1 || 0
        : parseInt($(nextStep).attr('step-number')) || 0;
    stepper.updateCurrentStepNumber(stepNumber);

    // Get steps types
    const previousStepType = getStepType(previousStep);
    const nextStepType = getStepType(nextStep);

    if (oppositeDirection && previousStepType === '') {
        [previousStep, nextStep] = [nextStep, previousStep];
    }

    // Create timeline
    const timeline = gsap.timeline({
        defaults: {
            duration: duration / 1000,
            ease: CustomEase.create('custom', 'M0,0 C0.59,0.2 0.25,1 1,1 '),
        },
        onComplete: (self) => { // eslint-disable-line no-unused-vars
            window.isLoading = false;
        },
    }).addLabel('start', 0);

    // Define stepper color based on step type
    let stepperColor = $(nextStep).css('--stepper__container--black')
    let isStepperBlack = stepperColor !== undefined && stepperColor.toLowerCase() === 'true';
    $('.stepper__container').toggleClass('stepper__container--black', isStepperBlack);

    // Define previous step leave animation

    animatePreviousStep(previousStep, previousStepType, timeline, oppositeDirection);
    // Remove previous step if we are in opposite direction
    if (oppositeDirection) {
        timeline.call( () => {
            $(previousStep).remove();
        },
        null,
        'end_of_previous_step'
        );
    }

    // Do some things if the step type is recommendation or not
    if (nextStepType === 'recommendation' || previousStepType === 'recommendation') {
        // Show the stepper back button
        timeline.to( '.stepper_pagination__back_button', { autoAlpha: 0 }, 'start' );

        // Add recommendation class to the product finder container
        $('#product-finder-container').addClass('product-finder-container--recommendation');
    } else {
        // Hide the stepper back button
        timeline.to( '.stepper_pagination__back_button', { autoAlpha: 1 }, 'start' );
    }

    // Define next step enter animation
    animateNextStep(nextStep, nextStepType, timeline, oppositeDirection);

    window.swiper_currentStepName = nextStepType;
    window.swiper_currentStep = nextStep;
    swiper.createSwiper();

    timeline
        .set( nextStep, { position: 'relative' }, '>' )
        .call(() => { slidingRadioButtons.scrollAnimation(); });
};

const defaultStepEnterAnimation = (nextStep, timeline, oppositeDirection) => {
    timeline
        .fromTo( nextStep, { position: 'absolute', yPercent: oppositeDirection ? -100 : 100 }, { yPercent: 0, clearProps: 'all' }, 0 )
        .call( () => { nextStep.focus(); }, null, '>' );
};

module.exports = {
    animateLoader,
    animateStepper,
    animateBeforeStep,
    animateSteps,
    animateStep,
    animatePreviousStepBackground,
    animateNextStepBackground,
    animateNextStep,
    animatePreviousStep
};
